export default "__VITE_ASSET__B71UVtf1__"